import { ReactNode, useLayoutEffect, useMemo } from 'react'
import ReactDOM from 'react-dom'
import { WIZARD_TOUR_PORTAL_ID } from './Types'

interface Props {
  children: ReactNode
}

export const WizardTourPortal = ({ children }: Props) => {
  const renderContainer = useMemo(() => document.createElement('div'), [])

  useLayoutEffect(() => {
    const externalMount = document.getElementById(WIZARD_TOUR_PORTAL_ID)
    externalMount?.appendChild(renderContainer)

    return () => {
      externalMount?.removeChild(renderContainer)
    }
  }, [renderContainer])

  return ReactDOM.createPortal(children, renderContainer)
}
